const FORMATTER = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

export const formatCurrency = (value: string | number | null | undefined, fallback = "—"): string => {
    if (value === null || value === undefined || value === "") return fallback;
    const n = typeof value === "string" ? Number(value) : value;
    if (!Number.isFinite(n)) return fallback;
    return FORMATTER.format(n);
};
